import { render, staticRenderFns } from "./new-schedule.vue?vue&type=template&id=ff6a231a&"
import script from "./new-schedule.vue?vue&type=script&lang=js&"
export * from "./new-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports